<template>
  <b-table
    small
    bordered
    head-variant="light"
    class="clinic-branch-summary mb-3"
    :items="summaryRows"
    :fields="summaryFields"
    :tbody-tr-class="rowClass"
    show-empty
  >
    <template #empty>
      <p class="text-center text-muted my-2">ไม่มีข้อมูลให้แสดง</p>
    </template>
  </b-table>
</template>

<script>
// Reusable "สรุปตามสาขา" table for the clinic income reports. Groups the detail
// rows by branch, sums each metric, and appends a grand-total row — this IS the
// "sum of all branches" roll-up. Presentation-only; parent owns the raw rows.
export default {
  name: "ClinicBranchSummary",
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    // [{ key, label }] — numeric fields to sum per branch.
    metrics: {
      type: Array,
      required: true,
    },
    groupKey: {
      type: String,
      default: "branchName",
    },
    groupLabel: {
      type: String,
      default: "สาขา",
    },
    totalLabel: {
      type: String,
      default: "รวมทุกสาขา",
    },
  },
  computed: {
    summaryFields() {
      return [
        { key: "_group", label: this.groupLabel, class: "narrow-spacing" },
        ...this.metrics.map(m => ({
          key: m.key,
          label: m.label,
          class: "text-right",
          formatter: this.formatNumber,
        })),
      ];
    },
    summaryRows() {
      const map = new Map();
      for (const r of this.rows) {
        const group = r[this.groupKey] || "ไม่ระบุสาขา";
        if (!map.has(group)) {
          const seed = { _group: group };
          for (const m of this.metrics) seed[m.key] = 0;
          map.set(group, seed);
        }
        const acc = map.get(group);
        for (const m of this.metrics) {
          const v = Number(r[m.key]);
          if (!isNaN(v)) acc[m.key] = Math.round((acc[m.key] + v) * 100) / 100;
        }
      }

      const branchRows = [...map.values()].sort((a, b) =>
        String(a._group).localeCompare(String(b._group), "th")
      );
      if (branchRows.length === 0) return [];

      const total = { _group: this.totalLabel, _isTotal: true };
      for (const m of this.metrics) total[m.key] = 0;
      for (const row of branchRows) {
        for (const m of this.metrics) {
          total[m.key] = Math.round((total[m.key] + row[m.key]) * 100) / 100;
        }
      }
      return [...branchRows, total];
    },
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined || isNaN(value)) return "";
      return Number(value).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    rowClass(item) {
      return item && item._isTotal ? "text-bold table-secondary" : "";
    },
  },
};
</script>
